export class TipoAto {
    idTipoAto: number;
    siglaTipoAto: string;
    nomeTipoAto: string;
    prioridadeTipoAto: number;
}
